@if (walletManager.signedWalletSignal(); as wallet) {
  <div class="wallet-chip-wrapper" (keydown.escape)="closeDropdown()">
    <button
      class="wallet-avatar-btn"
      [class.wallet-avatar-btn--md]="!compact()"
      type="button"
      [attr.aria-label]="
        'Open wallet for ' + (wallet.walletAddress | truncateWalletAddress)
      "
      [attr.aria-expanded]="dropdownOpen()"
      (click)="toggleDropdown()"
    >
      <kc-wallet-avatar
        [address]="wallet.walletAddress"
        [size]="compact() ? 'xs' : 'sm'"
      />
    </button>

    @if (dropdownOpen()) {
      <div
        class="wallet-dropdown-overlay"
        aria-hidden="true"
        (click)="closeDropdown()"
      ></div>
      <div class="wallet-dropdown" role="menu">
        <div class="wallet-dropdown__header">
          <kc-wallet-avatar [address]="wallet.walletAddress" size="sm" />
          <span
            class="wallet-dropdown__address"
            role="button"
            tabindex="0"
            [attr.aria-label]="copied() ? 'Copied!' : 'Copy address'"
            (click)="copyAddress(wallet.walletAddress)"
            (keydown.enter)="copyAddress(wallet.walletAddress)"
            (keydown.space)="
              $event.preventDefault(); copyAddress(wallet.walletAddress)
            "
          >
            {{ wallet.walletAddress | truncateWalletAddress: 10 : 6 }}
            <kc-icon
              class="copy-icon"
              [iconClass]="copied() ? 'check' : 'copy-01'"
              size="xs"
              [color]="
                copied() ? 'var(--kc-color-teal-400, #6fc7ba)' : 'currentColor'
              "
            />
          </span>
        </div>

        <div class="wallet-dropdown__actions">
          @if (wallet.walletType === kaspaComWalletType) {
            <kc-button
              variant="secondary"
              size="m"
              text="Open wallet"
              prefixIcon="kaspa-wallet"
              [isFullWidth]="true"
              (buttonClick)="openWallet()"
            />
          }
          <div class="wallet-dropdown__theme-toggle">
            <kc-button
              variant="secondary"
              size="m"
              [text]="
                themeService.theme() === 'dark' ? 'Light mode' : 'Dark mode'
              "
              prefixIcon="theme"
              [isFullWidth]="true"
              (buttonClick)="toggleTheme()"
            />
          </div>
          <kc-button
            variant="secondary"
            size="m"
            text="Disconnect"
            prefixIcon="log-out-01"
            [isFullWidth]="true"
            (buttonClick)="disconnect()"
          />
        </div>
      </div>
    }
  </div>
} @else {
  <kc-button
    variant="primary"
    size="m"
    [text]="compact() ? 'Connect' : 'Connect Wallet'"
    [isLoading]="walletManager.isConnectingToWalletState()"
    loadingText="Connecting"
    (buttonClick)="connect()"
  />
}
